/* eslint-disable prefer-destructuring */
import { SyncableSubscriptionFields } from '@weblite/ts-action/subscription'
import { eventBasedSynchronizer } from '$logic/lib/sync/event-based'

type SubscriptionUpdatePatch = Omit<SyncableSubscriptionFields, 'hallId'>

const synchronizer = eventBasedSynchronizer<SubscriptionUpdatePatch, true>(
  'subscriptionSync',
  { merge: true },
)

export const set = synchronizer.set
export const getAll = synchronizer.getAll
export const getIds = synchronizer.getIds
